import * as Yup from 'yup';
import { YupString, YupStringWithoutRequired } from './general';

export const donorSchema = Yup.object().shape({
  profileId: YupString,
  createdAt: YupString,
  remarks: YupStringWithoutRequired.nullable(),
});
